import { cn } from '@/shared/helpers/classnames'

import type { FC } from 'react'

import {
  Content as RadixDropdownContent,
  Portal as RadixDropdownPortal,
} from '@radix-ui/react-dropdown-menu'

import type { SelectContentProps } from './types'

/**
 * SelectContent component - Dropdown content of the select
 *
 * @example
 * ```tsx
 * <Select.Content mode="single">
 *   {options.map(option => (
 *     <Select.Option key={option.value} option={option} />
 *   ))}
 * </Select.Content>
 * ```
 */
export const SelectContent: FC<SelectContentProps> = ({
  children,
  mode = 'single',
  header,
  size = 'md',
}) => {
  // Common content for both modes
  const viewportContent = <>{children}</>

  // Classes for wrapper based on size
  const wrapperClasses = cn({
    'selectw-sm': size === 'sm',
    'selectw-md': size === 'md',
    'selectw-lg': size === 'lg',
    'selectw-single': mode === 'single',
    'selectw-multiple': mode === 'multiple',
    'selectw-group': mode === 'group',
  })

  return (
    <RadixDropdownPortal>
      <RadixDropdownContent className={cn('selectw-content', wrapperClasses)} align="start">
        {header}
        <div className="selectw-viewport">{viewportContent}</div>
      </RadixDropdownContent>
    </RadixDropdownPortal>
  )
}

SelectContent.displayName = 'SelectContent'
